import { PlanId } from '@/contexts/SubscriptionContext';

const STORE_ELIGIBLE_PLANS: Set<PlanId> = new Set(['pro', 'business']);

interface StoreLinkVisibilityInput {
  storeLinkEnabled?: boolean;
  activeProductsCount: number;
  planId?: PlanId;
}

export function shouldShowStoreLink({
  storeLinkEnabled = false,
  activeProductsCount,
  planId = 'free',
}: StoreLinkVisibilityInput): boolean {
  if (!STORE_ELIGIBLE_PLANS.has(planId)) return false;
  if (!storeLinkEnabled) return false;
  return activeProductsCount > 0;
}

export function isStoreEligible(planId: PlanId): boolean {
  return STORE_ELIGIBLE_PLANS.has(planId);
}
